module.exports = __webpack_public_path__ + "static/media/Add Blue.8224081a.svg";